module.exports = {
  public: '全体に公開',
  privateOnly: '自分だけ',
  privateWith: 'パートナーとだけ',
};